import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Spinner } from '@panel/commons/lib/Spinner/Spinner';
import { getColor } from '@panel/commons/core/themev3';
import { select } from '@panel/commons/core/themev2';
import IconStars from '../../../../assets/icons/IconStarsIA.svg';

const LoaderAI = ({ height = '48px' }) => {
  const { t } = useTranslation();
  return (
    <Container height={height}>
      <div className='loader-text'>
        <div>{t('professionalPubli.description.AI.generating')}</div>
        <img src={IconStars} height='20px' width='20px' alt='Icono de IA' />
      </div>
      <div className='loader-spinner'>
        <Spinner size='24' lineWidth='2' color={getColor('primary')} />
      </div>
    </Container>
  );
};

export default LoaderAI;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: ${props => props.height};
  width: 100%;
  padding: 0 16px;
  border-radius: 8px;
  border: 1px solid ${getColor('primary')};
  .loader-text {
    display: flex;
    align-items: center;
    gap: 4px;
    color: ${select('neutralDarkGrayII')};
    text-align: center;
    font-family: Hind;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
  }
  .loader-spinner {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    margin-bottom: 24px;
  }
`;
